import { createComponentHealth } from '@shared/components/ComponentHealth';

export const [wrapWithCreateAccountHealthProvider, useCreateAccountHealth] = createComponentHealth('CreateWedding | Create account');
